/* eslint-disable import/prefer-default-export */
export const getFilter = searchableFields => (data, keyword) => {
  const targetWord = keyword.toLowerCase();
  return data.filter(item => {
    return searchableFields.find(fieldName =>
      `${item?.[fieldName]}`.toLowerCase()?.includes(targetWord)
    );
  });
};
